import { useState, useEffect } from 'react';

/**
 * Hook to detect if the device supports hover (mouse)
 * Returns true if hover is supported, false if touch/click should be used
 */
export function useHoverSupport() {
  const [canHover, setCanHover] = useState<boolean>(false);

  useEffect(() => {
    const mq = window.matchMedia('(hover: hover) and (pointer: fine)');
    setCanHover(mq.matches);

    const listener = (e: MediaQueryListEvent) => {
      setCanHover(e.matches);
    };

    // Listen for changes (e.g., dynamic switch between input types)
    if (mq.addEventListener) {
      mq.addEventListener('change', listener);
    } else {
      // Safari fallback
      mq.addListener(listener);
    }

    return () => {
      if (mq.removeEventListener) {
        mq.removeEventListener('change', listener);
      } else {
        mq.removeListener(listener);
      }
    };
  }, []);

  return canHover;
}
